import Component from '../inherited/Component'

export default class ReferenceImages extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
    this._referencesPoints = this._elem.querySelectorAll('.product-point')
  }

  mount () {
    const referencesPoints = this._referencesPoints
    const elem = this._elem
    document.addEventListener('DOMContentLoaded', function() {
        // Add 'click' event listener to each product point
        referencesPoints.forEach(function(productPoint) {
          productPoint.addEventListener('click', function(event) {
            event.stopPropagation();
      
            const currentTooltip = event.currentTarget.querySelector('.product-tooltip');
            const otherTooltips = elem.querySelectorAll('.product-tooltip:not(:scope)');
      
            // Close other open tooltips
            otherTooltips.forEach(function(tooltip) {
              if (tooltip !== currentTooltip) {
                tooltip.classList.add('hide');
              }
            });
      
            // Toggle the 'hide' class for the current tooltip
            currentTooltip.classList.toggle('hide');
          });
        });
      
        // Close all tooltips when clicking outside of product points
        document.addEventListener('click', function() {
          const tooltips = document.querySelectorAll('.product-tooltip');
          tooltips.forEach(function(tooltip) {
            tooltip.classList.add('hide');
          });
        });
      });

}
}